import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Single shared browser client. Auth is owned by our FastAPI backend, so we
// disable session persistence/auto-refresh here — this client is used purely
// for anonymous Realtime subscriptions on tables the user owns (RLS enforced
// on Postgres side via Dnya JWT-derived policies).
export const supabase = createClient(url, anon, {
  auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
});
